// Port of api/fuel/app/classes/filter/package/games/game/prepare/renames.php
export default {
	run: function(local, global) {
		local.rename = (global.renames && global.renames[local.game_id]) ? global.renames[local.game_id] : ''
		return local
	}
}
